<template>
  <div class="component-login">
    <div class="component-login-container">
      <div class="login-left">
        <div class="login-info">
          <h1>{{ $t('LandingPage.bigtitle') }}</h1>
          <h2>{{ $t('LandingPage.bigdescription') }}</h2>
        </div>
      </div>
      <div class="login-form">
        <h2>{{ $t("Login.login")}}</h2>
        <div class="login-box">
          <el-form status-icon>
            <el-alert class="alert-tips" :title="$t('Login.usernamepasswderror')" type="error" show-icon v-if="isLoginStatus"></el-alert>      
            <!-- <div style="position:absolute; left:-9999px;">
              <input type="text"><input type="password">
            </div> -->
            <el-form-item>
              <el-input type="text" autocomplete="off" :placeholder="$t('Login.email')" v-model="Verification.inputAdress.value"></el-input>
            </el-form-item>
            <el-form-item class="mb10">
              <el-input type="password" autocomplete="off" :placeholder="$t('Login.password')" v-model="Verification.inputPassword.value"></el-input>
            </el-form-item>
            <el-form-item class="mb10">
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="isRemenber" class="checked-password" :label="$t('Login.rememberme')" name="type"></el-checkbox>
                </el-col>
                <el-col :span="12">
                  <router-link class="link-to-lostpassword" to='/LostPassword'>{{ $t('Login.forgetpassword') }}？</router-link>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
                <div id="check-slide"></div>
            </el-form-item>
            <el-form-item class="mb10">
              <el-button class="login-button" type="primary" @click="onLogin">{{ $t("Login.login")}}</el-button>
            </el-form-item>
            <div class="login-ro-signup">
              <p>{{ $t('Login.donthaveanaccount') }}？<router-link to='/Signup'>{{ $t("Login.signup")}}</router-link></p>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="dialogsiginup_error" 
      center 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <span class="modal-error-icon"></span>
      <h3>邮箱尚未激活，请激活后登录</h3>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogsiginup_error = false" class="btn-bluelight">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="emailchecked" 
      center 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <span class="modal-success-icon"></span>
      <h3>邮箱已激活</h3>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="redirectToLogin" class="btn-bluelight">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog 
      class="signup-page-dialog" 
      :visible.sync="emailchecked2" 
      center 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <span class="modal-error-icon"></span>
      <h3>请勿重复激活</h3>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="redirectToLogin" class="btn-bluelight">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/js/jquery.slide.min.js'
export default {
  data: function() {
    return {
      emailchecked: false,
      emailchecked2: false,
      dialogsiginup_error: false,
      isEmailStatus: false,
      isLoginStatus: false,
      isPasswordError: false,
      isActive: false,
      Verification: {
        inputAdress: { value: "", icon: 1, status: "" },
        inputPassword: { value: "", icon: 1, status: "" }
      },
      slideResult: false,
      isRemenber: false,
      isPasswordStatusInfo: false,
      isEmailStatusInfo: false
    };
  },

  mounted() {
    
    let that = this
    if(localStorage.getItem("token")){
      that.getKf5SsoToken()
    }

    /**
     * 验证注册邮箱
     */
    if(that.$route.query.activate_token){
      let url = that.API_URL + '/v3/verify/activate'
      let checkemail = {
        activateToken: that.$route.query.activate_token,
        uuid: that.$route.query.uuid
      }
      $.ajax({
        url: url,
        type: "PUT",
        data: checkemail,
        success: function(rex) {
          console.log(rex)
          that.emailchecked = true
        },
        error: function(response) {
          console.log(response)
          that.dialogsiginup_error = true
        }
      })
    }
    
    /**
     * 滑动验证
     */
    $("#check-slide").slider({
      width: 320,
      height: 40,
      sliderBg: "#E8E8E8",
      color: "#666",
      fontSize: 14,
      bgColor: "#E8E8E8",
      textMsg: that.$t('Login.dragtoright'),
      successMsg: that.$t('Login.verificationpassed'),
      successColor: "#fff",
      time: 400, // 返回时间
      callback: function(result) {
        if (result) {
          $("#check-slide").addClass("success");
          $('.ui-slider-text').html(that.$t('Login.verificationpassed'));
        }
        that.slideResult = result;
      }
    })

    /**
     * 获取用户保存的密码
     */
    if(localStorage.getItem("loginemail")&&localStorage.getItem("loginpasswd")){
      that.isRemenber = JSON.parse(localStorage.getItem("isremenber")).val
      that.Verification.inputAdress.value = JSON.parse(localStorage.getItem("loginemail")).val
      that.Verification.inputPassword.value = JSON.parse(localStorage.getItem("loginpasswd")).val
    }
    
  },

  methods : {

    /**
     * 重定向登录页
     */
    redirectToLogin(){
      this.emailchecked = false
      this.emailchecked2 = false
      this.$router.push({
        path:'./Login'
      })
    },

    /**
     * 请求登录接口
     */
    onLogin: function(){
      let that = this
      let url = that.API_URL + '/v3/users/login'
      let logindata = {
        email: that.Verification.inputAdress.value,
        password: that.Verification.inputPassword.value
      }
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(logindata),
        success: function(data) {

          if(data.message === 'unactivate'){
            that.dialogsiginup_error = true
          }else{

            /**
             * 记住密码
             */
            if (that.isRemenber === true) {
              that.setLocalStorage( "isremenber", true )
              that.setLocalStorage( "loginemail", that.Verification.inputAdress.value )
              that.setLocalStorage( "loginpasswd", that.Verification.inputPassword.value )
            }

            if (that.isRemenber === false) {
              that.setLocalStorage( "isremenber", false )
              window.localStorage.removeItem('loginemail')
              window.localStorage.removeItem('loginpasswd')
            }

            that.setLocalStorage( "token", data.token )
            that.setLocalStorage( "code", data.code )
            that.setLocalStorage( "name", data.user.name )
            that.setLocalStorage( "phone", data.user.phone )
            that.setLocalStorage( "pbiurl", data.user.url )
            that.setLocalStorage( "email", data.user.email )
            that.setLocalStorage( "company", data.user.company )
            that.setLocalStorage( "balance", data.balance )
            that.setLocalStorage( "commmerce", data.package.commmerce )
            that.setLocalStorage( "digital", data.package.digital )
            that.setLocalStorage( "price", data.package.price )
            that.setLocalStorage( "status", data.package.commmerce.length > 0 ? 1 : 0 )
            that.setLocalStorage( "statusvip", data.package.digital.length > 0 ? 1 : 0 )
            that.setLocalStorage( "statusvip3", data.package.digital.length > 0 ? 3 : 0 )
            
            /**
             * 1、登录后优先进入价格监控页
             * 2、没有价格监控模块，默认进入电商防线
             * 3、进入到价格监控静态页
             */
            if(data.package.price.length > 0){
              let defaultIds = data.package.price[0].subid
              that.$router.push({name: 'PriceMonitoringProduct', params: {Id: defaultIds}})
            }else{
              if(data.package.commmerce.length > 0){
                let defaultId = data.package.commmerce[0].id
                that.$router.push({name: 'Product', params: {Id: defaultId}})
              }else{
                that.$router.push({ path: "/PriceMonitoring" })
              }
            }
            
          }
          that.getKf5SsoToken()
        },
        error: function(response) {
          //账号密码错误
          console.log('--login-error',response);
          if(response.responseJSON.login_status === 2){
            that.dialogsiginup_error = true
          }else{
            that.isLoginStatus = true
          }
        }
      })
    },

    /**
     * 获取kf5 SSO Token
     */
    getKf5SsoToken: function(){
      let that = this
      let url = that.API_URL + '/v3/users/kftoken'
      $.ajax({
        url:  url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getKf5SsoToken', rex)
          window.location.href='http://simplybrand.kf5.com/user/remote?username=' + rex.username 
          + '&time=' + rex.time 
          + '&token=' + rex.token
          //+ '&return_to=' + that.$route.query.return_to
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

  }

}
</script>

<style scoped>
.alert-tips,
.el-form-item.mb10{
  margin-bottom: 10px;
}
.component-login{
  min-height: 500px;
  padding-top: 50px;
  height: calc(100vh - 80px);
  background-image: url(../assets/img/login-bg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}
.component-login-container{
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.component-login-container:before,
.component-login-container:after{
  content: '';
  display: block;
}
.component-login-container:after{
  clear: both;
}
.login-left{
  width: calc(100% - 700px);
  height: 100%;
  font-size: 0;
  line-height: calc( 100vh - 60px - 78px);
}
.login-left h1 {
  font-size: 48px;
  color: #000000;
  line-height: 60px;
  margin-bottom: 20px;
  font-weight: normal;
}
.login-left h2 {
  font-size: 20px;
  color: #000000;
  line-height: 36px;
  font-weight: normal;
}
.login-info{
  display: inline-block;
  padding-left: 200px;
  vertical-align: middle;
  line-height: 1rem;  
}
.login-form {
  width: 400px;
  display: inline-block;
  background: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06);
  padding: 60px 40px;
  right: 240px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.login-form h2{
  font-weight: normal;
}
.login-box{
  margin-top: 30px;
}
.link-to-lostpassword{
  float: right;
  text-decoration: none;
  color: #999;
}
.login-button{
  width: 100%;
}
.login-ro-signup p{
  margin: 0;
  color: #999;
}
.login-ro-signup p a{
  color: #007bff;
  text-decoration: none;
}
.checked-password{
  color: #999;
}
</style>
